/* eslint-disable jsx-a11y/alt-text */
import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import './Tree-Center.css';

export default function TreeCenter() {
  const { settings, toysOnTree } = React.useContext(AppContext);
  const dragStart = (e: React.DragEvent<HTMLImageElement>) => {
    const { id, dataset } = e.target as HTMLElement;
    e.dataTransfer.setData('data', JSON.stringify({ id, dataset }));
  };
  return (
    <div>
      <map name="tree-map">
        <area
          id="tree-map-area"
          shape="poly"
          coords="365,699,189,706,113,683,31,608,2,555,2,539,18,437,73,351,106,224,161,134,243,-1,306,75,353,144,399,221,424,359,452,459,496,550,444,664"
        />
      </map>
      <img
        className="tree-center"
        src={`./assets/tree/${settings.tree}.png`}
        alt="tree"
        useMap="#tree-map"
      />
      {toysOnTree.map((el) => (
        <img
          id={el.id}
          data-index={el.index}
          key={el.index + el.id}
          draggable
          onDragStart={dragStart}
          className="chosens-toy__image"
          src={`./assets/toys/${el.id}.png`}
          style={{ position: 'absolute', top: el.y - 90, left: el.x - 30 }}
          alt="toy"
        />
      ))}
    </div>
  );
}
